import React from "react";
import logo from "../../assets/logo/beelogo.png";

const ThankYou = () => {

  return (
    <>
      {/* <div style={{ height: "100px" }}></div> */}
      <div style={{ height: "100vh" }} className="d-flex jc-center ai-center">
        <div className="thank-you gap-2 text-center d-flex jc-center flex-row ai-center" >
          <div className="thank-you2">
            <div className="text-start">
              מעוניינים בחתימה אלקטרונית? <br /> מערכת הכוורת מאפשרת ניהול חכם כולל! <br /><a href="https://www.kaveret.biz">לחצו לפרטים</a>
            </div>
            <img width={150} alt="the bee" src={logo} />
          </div>
          <div style={{ textAlign: "center", marginBottom: "200px" }}>
            <h1>תודה רבה!</h1>
            <h3>חתימתך נשמרה</h3>
          </div>
        </div>
      </div>
    </>
  );
};

export default ThankYou;
